"use client";

import React from "react";
import Image from "next/image";
import defaultProfile from "@/images/default-profile.jpg";
import FollowButton, { ButtonVariant } from "./followButton";
import { HoverableMention } from "./HoverableMention";
import type { MentionedUser } from "./WhoToFollow";

interface SuggestedUserCardProps {
  user: MentionedUser;
}

const SuggestedUserCard: React.FC<SuggestedUserCardProps> = ({ user }) => {
  return (
    <div className="flex flex-1 flex-col gap-2 p-3">
      <div className="flex flex-row justify-center items-center w-full">
        <div className="flex flex-row justify-start items-start w-full">
          <div className="flex items-center justify-start max-w-fit min-w-10">
            <Image
              src={
                user?.profile_picture?.thumbnail_url ||
                user?.profile_picture?.url ||
                defaultProfile
              }
              alt={user?.name || ""}
              width={80}
              height={80}
              className="w-10 h-10 mr-3 object-cover rounded-full"
            />
          </div>
          <div className="flex flex-col max-w-36 min-w-5 ml-1.5 pr-2">
            <div>
              <HoverableMention user={user} variant="whoToFollow">
                <div
                  className={`${
                    user?.display_name && user.display_name.length <= 12
                      ? "flex flex-row gap-1 items-center"
                      : "flex flex-col gap-1"
                  }`}
                >
                  <p
                    className="font-bold text-sm truncate max-w-full group-hover:whitespace-normal group-hover:overflow-visible"
                    title={user?.display_name}
                  >
                    {user?.display_name}
                  </p>

                  <p
                    className="text-xs text-muted-foreground max-w-full truncate"
                    title={`@${user?.name.toLowerCase().replace(/\s+/g, "")}`}
                  >
                    @{user?.name.toLowerCase().replace(/\s+/g, "")}
                  </p>
                </div>
              </HoverableMention>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-start mt-2">
          <FollowButton
            _user={user}
            variant={ButtonVariant.ICON_ONLY}
            buttonOrientation="column"
          />
        </div>
      </div>
    </div>
  );
};

export default SuggestedUserCard;
